/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_My_DriveInputs */

const en_explorer_nav_my_drive = /** @type {(inputs: Explorer_Nav_My_DriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Drive`)
};

const fr_explorer_nav_my_drive = /** @type {(inputs: Explorer_Nav_My_DriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mon Drive`)
};

const de_explorer_nav_my_drive = /** @type {(inputs: Explorer_Nav_My_DriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mein Laufwerk`)
};

const it_explorer_nav_my_drive = /** @type {(inputs: Explorer_Nav_My_DriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La mia guida`)
};

const ru_explorer_nav_my_drive = /** @type {(inputs: Explorer_Nav_My_DriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Моя поездка`)
};

const es_explorer_nav_my_drive = /** @type {(inputs: Explorer_Nav_My_DriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi unidad`)
};

const zh_cn2_explorer_nav_my_drive = /** @type {(inputs: Explorer_Nav_My_DriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的硬盘`)
};

const ja_explorer_nav_my_drive = /** @type {(inputs: Explorer_Nav_My_DriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マイドライブ`)
};

const hi_explorer_nav_my_drive = /** @type {(inputs: Explorer_Nav_My_DriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेरी ड्राइव`)
};

const pt_pt2_explorer_nav_my_drive = /** @type {(inputs: Explorer_Nav_My_DriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minha direção`)
};

/**
* | output |
* | --- |
* | "My Drive" |
*
* @param {Explorer_Nav_My_DriveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_my_drive = /** @type {((inputs?: Explorer_Nav_My_DriveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_My_DriveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_nav_my_drive(inputs)
	if (locale === "de") return de_explorer_nav_my_drive(inputs)
	if (locale === "it") return it_explorer_nav_my_drive(inputs)
	if (locale === "ru") return ru_explorer_nav_my_drive(inputs)
	if (locale === "es") return es_explorer_nav_my_drive(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_nav_my_drive(inputs)
	if (locale === "ja") return ja_explorer_nav_my_drive(inputs)
	if (locale === "hi") return hi_explorer_nav_my_drive(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_nav_my_drive(inputs)
	return en_explorer_nav_my_drive(inputs)
});